import React from "react";

export const TimeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none">
      <path
        d="M30.4747 5.08398C16.4447 5.08398 5.0835 16.4707 5.0835 30.5006C5.0835 44.5306 16.4447 55.9173 30.4747 55.9173C44.5302 55.9173 55.9168 44.5306 55.9168 30.5006C55.9168 16.4707 44.5302 5.08398 30.4747 5.08398ZM40.6668 40.6673C40.4317 40.9029 40.1524 41.0899 39.8449 41.2174C39.5374 41.345 39.2078 41.4106 38.875 41.4106C38.5421 41.4106 38.2125 41.345 37.905 41.2174C37.5975 41.0899 37.3182 40.9029 37.0831 40.6673L28.721 32.3052C28.4808 32.0698 28.2898 31.7891 28.1589 31.4794C28.028 31.1696 27.9599 30.8369 27.9585 30.5006V20.334C27.9585 18.9361 29.1022 17.7923 30.5002 17.7923C31.8981 17.7923 33.0418 18.9361 33.0418 20.334V29.4586L40.6668 37.0836C41.6581 38.0748 41.6581 39.6761 40.6668 40.6673Z"
        fill="#2481A6"
      />
    </svg>
  );
};
